import React, { useEffect, useRef, useState } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import DateRange from "./main/DateRange";
import axios from "axios";
import Swal from "sweetalert2";

export default function StrategyUpdate() {
  const [stacks, setStacks] = useState(false);
  const [selectedStack, setSelectedStack] = useState(null);
  const [colStart, setColStart] = useState("");
  const [colEnd, setColEnd] = useState("");
  const [loading, setLoading] = useState(false);
  const [PlanType, setPlanType] = useState(false);
  const [data, setData] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const handleStackChange = (event) => {
    const stackId = parseInt(event.target.value);
    const selected = stacks.find((stack) => stack.id === stackId);
    setSelectedStack(selected);
    setColStart(selected?.col_start || "N/A");
    setColEnd(selected?.col_end || "N/A");
  };

  useEffect(() => {
    if (id) {
      fetchStacks();
      GetData();
    }
  }, [id]);

  useEffect(() => {
    if (data && stacks) {
      setPlanType(data?.plan_type);
     let  stackId =data?.stack_id;
      const selected = stacks.find((stack) => stack.id == stackId);
      setSelectedStack(selected);
      setColStart(selected?.col_start || "N/A");
      setColEnd(selected?.col_end || "N/A");
    }
  }, [data,stacks]);

  const GetData = async () => {
    setLoading(true);
     let url=`https://ctas.live/backend/api/get/yard/planning/info/${id}`;
    try {
      const response = await axios.get(url);
      if (response.data && response.data.data) {
        setData(response.data.data);
      } else {
        Swal.fire({
          icon: "info",
          text: `Something Went Wrong..!`,
          timer: 3000,
        });
      }
    } catch (error) {
      console.error("Error fetching stacks:", error);
      Swal.fire({
        icon: "error",
        text: `Something Went Wrong..! ${error}`,
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchStacks = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://ctas.live/backend/api/get/yard/stacks"
      );
      if (response.data && response.data.data) {
        setStacks(response.data.data);
      } else {
        Swal.fire({
          icon: "info",
          text: `Something Went Wrong..!`,
          timer: 3000,
        });
      }
    } catch (error) {
      console.error("Error fetching stacks:", error);
      Swal.fire({
        icon: "error",
        text: `Something Went Wrong..! ${error}`,
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const SubmitPlan = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);
    const formValues = Object.fromEntries(formData.entries());
    formValues.created_by = "1";
    formValues.id = id;
    formValues.stack_name = selectedStack?.name;
    formValues.stack_id = selectedStack?.id;
    formValues.plan_type = PlanType;
    formValues.stack_rows =
      selectedStack?.row_start + "-" + selectedStack?.row_end;
    const payload = formValues;

    const url = `https://ctas.live/backend/api/update/yard/planning`;

    try {
      const response = await axios.post(url, payload, {
        headers: {
          "Content-Type": "application/json",
          // "access_token": `${AccessToken}`,
        },
      });
      if (response.data && response.data.status) {
        Swal.fire({
          icon: "success",
          text: "Successfully",
          timer: 3000,
          showConfirmButton: false,
        }).then(() => {
          navigate("/strategy");
        });
      } else {
        Swal.fire({
          icon: "info",
          text: `Something Went Wrong..!`,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleColStartChange = (event) => {
    let value = event.target.value;
    if (selectedStack && value < selectedStack.col_start) {
      value = selectedStack.col_start;
    }
    setColStart(value);
  };
  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <div className="col">
                    <h3 className="text-primary">Yard Strategy Update</h3>
                  </div>
                  <div className="col text-end">
                    <Link to={"/strategy"} className="btn btn-sm btn-primary">
                      Go Back
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <h5>Yard Planning Form</h5>
                          <hr />
                        </div>
                        <div className="col-md-6 mb-4">
                          <select
                            className="form-control"
                            onChange={(e) => setPlanType(e.target.value)}
                            defaultValue={PlanType}
                          >
                            <option value="" disabled selected>
                              Planning Strategy
                            </option>
                            <option value="gate_in"> Gate In </option>
                            <option value="rake_in"> rake In </option>
                            <option value="import_wh">Import Warehouse</option>
                            <option value="export_wh">Export Warehouse</option>
                          </select>
                        </div>
                        {PlanType && (
                          <form className="" onSubmit={SubmitPlan}>
                            {PlanType == "gate_in" || PlanType == "rake_in" ? (
                              <>
                                <div className="row">
                                  <div className="mb-3 col-md-6">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label"
                                    >
                                      Select Stack
                                    </label>
                                    <select
                                      name="stack_name"
                                      id=""
                                      className="form-control"
                                      onChange={handleStackChange}
                                      defaultValue={selectedStack?.id}
                                    >
                                      <option value="" disabled selected>
                                        Select Stacks
                                      </option>

                                      {stacks.map((stack) => (
                                        <option key={stack.id} value={stack.id}>
                                          {stack.name}
                                        </option>
                                      ))}
                                    </select>
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label"
                                    >
                                      Select Rows{" "}
                                    </label>{" "}
                                    <b>
                                      From : {selectedStack?.row_start ?? ""}{" "}
                                    </b>
                                    <b>To : {selectedStack?.row_end ?? ""} </b>
                                  </div>

                                  <div className="mb-3 col-md-3">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label"
                                    >
                                      Col From
                                    </label>
                                    <input
                                      type="number"
                                      name="location_from"
                                      className="form-control col-md-6"
                                      value={colStart}
                                      onChange={handleColStartChange}
                                    />
                                    <b>
                                      Min Value :{" "}
                                      {selectedStack?.col_start ?? ""}{" "}
                                    </b>
                                  </div>

                                  <div className="mb-3 col-md-3">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label"
                                    >
                                      Col To
                                    </label>
                                    <input
                                      name="location_to"
                                      type="number"
                                      className="form-control col-md-6"
                                      defaultValue={colEnd ?? 0}
                                      min={colStart ?? 0} // Set min from ColStart
                                      max={selectedStack?.col_end ?? 0} // Set max from ColEnd
                                      onInput={(e) => {
                                        let value = Number(e.target.value);
                                        let minValue = colStart ?? 0;
                                        let maxValue =
                                          selectedStack?.col_end ?? 0;

                                        // Ensure value is within range
                                        if (value < minValue) {
                                          e.target.value = minValue;
                                          setColEnd(minValue); // Update ColEnd
                                        } else if (value > maxValue) {
                                          e.target.value = maxValue;
                                          setColEnd(maxValue); // Update ColEnd
                                        } else {
                                          setColEnd(value); // Update ColEnd with user input
                                        }
                                      }}
                                    />
                                    <b>
                                      Max Value : {selectedStack?.col_end ?? ""}{" "}
                                    </b>
                                  </div>

                                  <div className="mb-3 col-md-6">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label"
                                    >
                                      Container Type
                                    </label>
                                    <select
                                      name="container_type"
                                      id=""
                                      className="form-control"
                                      defaultValue={data?.container_type}
                                    >
                                      <option value="" selected disabled>
                                        Select Container Type
                                      </option>
                                      <option value="Empty">Empty</option>
                                      <option value="Loaded">Loaded</option>
                                    </select>
                                  </div>

                                  <div className="mb-3 col-md-6">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label"
                                    >
                                      Container Size
                                    </label>
                                    <select
                                      name="container_size"
                                      id=""
                                      className="form-control"
                                      defaultValue={data?.container_size}
                                    >
                                      <option value="" selected disabled>
                                        Select Container Size
                                      </option>
                                      {/* <option value="all">All</option> */}
                                      <option value="20">20 Feet</option>
                                      <option value="40">40 Feet</option>
                                    </select>
                                  </div>

                                  <div className="mb-3 col-md-6">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label"
                                    >
                                      HAZ
                                    </label>
                                    <select
                                      name="is_haz"
                                      id=""
                                      className="form-control"
                                      defaultValue={data?.is_haz}
                                    >
                                      <option value="N">No</option>
                                      <option value="Y">Yes</option>
                                    </select>
                                  </div>
                                </div>
                                <button type="submit" className="btn btn-primary">
                                  Submit
                                </button>
                              </>
                            ) : (
                              <>
                                <h5 className="text-danger">
                                  Warehouse ({PlanType}) Planing Comming Soon
                                </h5>
                                <hr />
                              </>
                            )}
                          </form>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
}
